import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const QuestionMarkShape = ({ width = 36, height = 36, style }: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 29 29"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0108 9.45127C11.4158 8.26064 12.7541 7.24967 14.5 7.24967C16.6587 7.24967 18.125 8.74866 18.125 10.2705C18.125 11.7924 16.6587 13.2913 14.5 13.2913C13.8326 13.2913 13.2917 13.8323 13.2917 14.4997V16.9163C13.2917 17.5837 13.8326 18.1247 14.5 18.1247C15.1674 18.1247 15.7083 17.5837 15.7083 16.9163V15.5971C18.3703 15.104 20.5417 13.0141 20.5417 10.2705C20.5417 7.12095 17.6802 4.83301 14.5 4.83301C11.867 4.83301 9.5063 6.36983 8.72289 8.67308C8.508 9.30487 8.84597 9.99125 9.47776 10.2061C10.1096 10.421 10.7959 10.0831 11.0108 9.45127ZM14.5 24.1663C15.5011 24.1663 16.3125 23.3548 16.3125 22.3538C16.3125 21.3529 15.5011 20.5413 14.5 20.5413C13.499 20.5413 12.6875 21.3529 12.6875 22.3538C12.6875 23.3548 13.499 24.1663 14.5 24.1663Z"
      fill="#000"
    />
  </svg>
);

export default QuestionMarkShape;
